import React from 'react';
import { AlertCircle } from 'lucide-react';
const situations = ['Terminaste la facultad y la práctica real no se parece a lo que estudiaste', 'Llegás a casa después de las consultas y todavía tenés que preparar el material de mañana', 'Buscás protocolos en grupos de WhatsApp de nutricionistas y en PDFs que no aplican a Argentina', 'Llegás a una consulta y en el fondo no estás seguro/a de que lo que hacés es lo más correcto', 'El paciente te pregunta qué marca comprar y tardás en responder porque no tenés la información organizada', 'Sabés que deberías cobrar más pero no tenés idea de cuánto debería ser ese número ni cómo decirlo', 'Querés que tu práctica proyecte la seguridad de alguien que sabe exactamente lo que hace'];
export function ForWhoSection() {
  return <section className="py-20 bg-brand-sand" data-id="element-75">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-77">
          Este sistema es para vos si...
        </h2>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-78">
          <div className="grid grid-cols-12 bg-gray-50 border-b border-gray-200 p-4 font-bold text-brand-teal" data-id="element-79">
            <div className="col-span-10 sm:col-span-11" data-id="element-80">Situación</div>
            <div className="col-span-2 sm:col-span-1 text-center" data-id="element-81">
              ¿Te pasa?
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-82">
            {situations.map((sit, i) => <div key={i} className="grid grid-cols-12 p-4 items-center hover:bg-gray-50 transition-colors" data-id="element-83">
                <div className="col-span-10 sm:col-span-11 text-gray-700 pr-4" data-id="element-84">
                  {sit}
                </div>
                <div className="col-span-2 sm:col-span-1 flex justify-center" data-id="element-85">
                  <AlertCircle className="w-6 h-6 text-brand-accent opacity-50" data-id="element-86" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}